import React from 'react';
import {
  CANCEL_TASK_ACTION,
  DOWNLOAD_TASK_ACTION,
  RETRY_TASK_ACTION,
  UPLOAD_TASK_ACTION,
} from '../../../../constants/chargerTask';

import CancelTaskAction from '../cancelAction';
import UploadTaskAction from '../uploadAction';
import RetryTaskAction from '../retryAction';
import DownloadTaskAction from '../downloadAction';

const ACTION_COMPONENT_MAP = {
  [CANCEL_TASK_ACTION]: CancelTaskAction,
  [UPLOAD_TASK_ACTION]: UploadTaskAction,
  [RETRY_TASK_ACTION]: RetryTaskAction,
  [DOWNLOAD_TASK_ACTION]: DownloadTaskAction,
};

function BaseAction(props) {
  const { action, task, ...rest } = props;
  const Component = ACTION_COMPONENT_MAP[action];

  return <Component task={task} {...rest} />;
}

export default BaseAction;
